const CSV_EXTENSION = ".csv";

function normalizeDownloadName(downloadFileName?: string): string | undefined {
    const trimmedName = downloadFileName?.trim();

    if (!trimmedName) {
        return undefined;
    }

    return trimmedName + "-list";
}

export function getExportFilename(downloadFileName?: string): string {
    const trimmedName = downloadFileName?.trim();

    // If the filename already has a file extension, use it as-is
    if (trimmedName && /\.\w+$/.test(trimmedName)) {
        return trimmedName;
    }

    const normalizedName = normalizeDownloadName(trimmedName) ?? "export";

    return `${normalizedName}${CSV_EXTENSION}`;
}
